import DeleteIcon from "@mui/icons-material/Delete";
import { Decimal } from "decimal.js";
import moment from "moment";
import { MDBIcon } from "mdb-react-ui-kit";
import { roundNumber, FORMATO_AM_PM, format_miles, MONEY_ROUND } from "./Util";
import { Box, IconButton } from "@mui/material";
import { dataTipo, imgURLLocalImageIp } from "./Services";
import { Label, Row, Col } from "reactstrap";
import { COOK_MAN } from "./Image";

export const COLUMNS_BODEGA =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b> {cell.row.original.bod_nombre}</b>
                  </span>{" "}
                  <br></br>
                  <span>{cell.row.original.com_alias}</span>
                  <br></br>
                  <span>{cell.row.original.bod_ubicacion}</span>
                  <br></br>
                </Col>
              </Row>
            );
          },
          accessorKey: "bod_nombre",
          header: "BODEGAS",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "bod_nombre",
          header: "NOMBRE",
          grow: true,
          Edit: () => null,
          enableEditing: false,
        },
        {
          accessorKey: "com_alias", //normal accessorKey
          header: "SUCURSAL",
          size: 100,
        },
        {
          accessorKey: "bod_ubicacion", //normal accessorKey
          header: "UBICACIÓN",
          size: 200,
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];
export const COLUMNS_CLIENTES_HISTORIAL = [
  {
    accessorKey: "fac_fecha",
    header: "FECHA",
    size: 90,
    // size: 350,
  },
  {
    accessorKey: "art_upc", //normal accessorKey
    header: "CÓDIGO",
    size: 80,
  },
  {
    accessorKey: "art_descripcion", //normal accessorKey
    header: "ARTÍCULO",
    size: 300,
  },
  {
    accessorKey: "cat_descripcion", //normal accessorKey
    header: "CATEGORIA",
    size: 200,
  },
  {
    accessorKey: "cantidad", //normal accessorKey
    header: "CANTIDAD",
    size: 60,
  },
  {
    accessorKey: "fac_total", //normal accessorKey
    header: "TOTAL",
    size: 60,
  },
];

export const COLUMNS_CLIENTES = [
  {
    accessorKey: "cli_nombre",
    header: "NOMBRE",
    size: 350,
  },
  {
    accessorKey: "cli_telefono", //normal accessorKey
    header: "TELÉFONO",
    size: 100,
  },
  {
    accessorKey: "cli_ruc", //normal accessorKey
    header: "RUC",
    accessorFn: (row) => `${row.cli_dv !== "" ? row.cli_ruc + " DV " + row.cli_dv : row.cli_ruc}`,
    align: "center",
    size: 150,
  },
  {
    accessorKey: "cli_limitc", //normal accessorKey
    header: "LÍMITE DE CRÉDITO",
    size: 120,
    muiTableBodyCellProps: {
      align: "center",
    },
  },
];
export const COLUMNS_PROVEEDORES = [
  {
    accessorKey: "prov_nombre",
    header: "NOMBRE",
    size: 350,
  },
  {
    accessorKey: "prov_telefono", //normal accessorKey
    header: "TELÉFONO",
    size: 100,
  },
  {
    accessorFn: (row) =>
      `${row.prov_dv !== "" ? row.prov_ruc + " DV " + row.prov_dv : row.prov_ruc}`,
    accessorKey: "prov_ruc", //normal accessorKey
    header: "RUC",
    size: 100,
  },
];
export const COLUMNS_DESCUENTO = [
  {
    accessorKey: "des_number",
    header: "% DESCUENTO",
    size: 350,
  },
  {
    accessorKey: "des_code",
    header: "NOMBRE",
    size: 350,
  },
];
export const COLUMNS_GARANTIA =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b> {cell.row.original.gr_name}</b>
                  </span>{" "}
                  <br></br>
                  <span>{cell.row.original.gr_descripcion}</span>
                  <br></br>
                </Col>
              </Row>
            );
          },
          accessorKey: "gr_name",
          header: "GARANTÍAS",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "gr_name",
          header: "NOMBRE",
          size: 350,
        },
        {
          accessorKey: "gr_descripcion",
          header: "DESCRIPCIÓN",
          size: 350,
        },
      ];
export const COLUMNS_MARCAS = [
  {
    accessorKey: "mar_descripcion",
    header: "MARCAS",
    size: 350,
  },
];
export const COLUMNS_CATEGORIAS = [
  {
    accessorKey: "cat_descripcion",
    header: "CATEGORÍAS",
    size: 350,
  },
];
export const COLUMNS_USUARIOS = window.innerWidth <= 611? [
        {
          header: "USUARIOS",
          accessorFn: (row) =>
            `${row.usr_usuario} ${row.usr_nombre} ${row.usr_perfil} ${row.com_nombre}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>USUARIO: {highlightText(row.original.usr_usuario, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    NOMBRE: {highlightText(row.original.usr_nombre, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    SUCURSAL: {highlightText(row.original.com_nombre, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    TIPO: {highlightText(row.original.usr_perfil, search)}
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "usr_usuario",
    header: "USUARIO",
    grow: true,
    minSize: 80,
    maxSize: 120,
  },
  {
    accessorKey: "usr_nombre",
    header: "NOMBRE",
    minSize: 80,
    maxSize: 120,
  },
  {
    accessorFn: (row) =>
      `${dataTipo[row.usr_perfil] !== undefined ? dataTipo[row.usr_perfil].label : null}`,
    accessorKey: "usr_perfil",
    header: "TIPO",
    minSize: 80,
    maxSize: 120,
  },
  {
    accessorKey: "com_nombre",
    accessorFn: (row) => `${row.com_nombre + " / " + row.com_alias}`,
    header: "SUCURSAL",
    minSize: 220,
    maxSize: 260,
  }
];
export function COLUMNS_PUBLICIDAD(setSrcImage, setModalImageTooltip) {
  return [
    {
      accessorKey: "img_name",
      Cell: ({ cell }) => {
        return (
          <>
            <img
              className="img-art-datatable-publicidad"
              alt=""
              onClick={() => {
                setSrcImage(imgURLLocalImageIp + cell.row.original.img_name);
                setModalImageTooltip(true);
              }}
              src={imgURLLocalImageIp + cell.row.original.img_name}
            />
          </>
        );
      },
      header: "IMÁGEN PUBLICIDAD",
      size: 360,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export const COLUMNS_ARTICULOS = window.innerWidth <= 611? [
        {
          header: "ARTÍCULOS",
          accessorFn: (row) => `${row.art_upc} ${row.art_descripcion} ${row.art_serie} ${row.art_referencia}  ${row.art_costo} ${row.art_precio} ${row.art_precio2} ${row.art_precio3} ${row.art_itbm_venta}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>CÓDIGO {highlightText(row.original.art_upc, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    {highlightText(row.original.art_descripcion, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    # SERIE: {highlightText(row.original.art_serie, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    REFERENCIA: {highlightText(row.original.art_referencia, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    COSTO: {highlightText(row.original.art_costo, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    PRECIO 1: {highlightText(row.original.art_precio, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    PRECIO 2: {highlightText(row.original.art_precio2, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    PRECIO 3: {highlightText(row.original.art_precio3, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    ITBM DE VENTA: {highlightText((Number(row.original.art_itbm_venta) * 100).toFixed(2) + "%", search)}
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "art_upc",
    header: "CÓDIGO",
    size: 150,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_restaurante",
    accessorFn: (row) => `${row.art_restaurante === "1" ? "SI" : ""}`,
    header: "RESTAURANTE",
    size: 150,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_descripcion",
    header: "DESCRIPCIÓN",
    size: 350,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "inv_qty",
    header: "CANTIDAD",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_costo",
    header: "COSTO",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_precio",
    header: "PRECIO",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_precio2",
    header: "PRECIO 2",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_precio3",
    header: "PRECIO 3",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "cat_descripcion",
    header: "CATEGORIA",
    size: 50,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "prov_nombre",
    header: "PROVEEDOR",
    size: 50,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "mar_descripcion",
    header: "MARCA",
    size: 30,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_referencia",
    header: "REFERENCIA",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_serie",
    header: "# SERIE",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_linea_roja",
    header: "LÍNEA ROJA",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "art_itbm_venta",
    header: "ITBM VENTA",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    accessorFn: (row) => `${(Number(row.art_itbm_venta) * 100).toFixed(2) + "%"}`,
  },
  {
    accessorKey: "art_itbm_compra",
    header: "ITBM COMPRA",
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    accessorFn: (row) => `${(Number(row.art_itbm_compra) * 100).toFixed(2) + "%"}`,
  },
];

export const COLUMNS_REPORT_INFORME_CAJA = [
  {
    accessorKey: "fac_fecha",
    header: "Fecha",
  },
  {
    accessorKey: "cli_nombre",
    header: "Cliente",
  },

  {
    accessorKey: "cli_ruc",
    header: "RUC",
  },
  {
    accessorKey: "usr_nombre",
    header: "Vendedor",
  },
  {
    accessorKey: "fac_caja",
    header: "Caja",
    // size: 450,
  },
  {
    accessorKey: "fac_motivo_anulacion",
    header: "Motivo",
    // size: 450,
  },
  {
    accessorKey: "fac_date_anulacion",
    header: "Fecha de anulacion",
    // size: 450,
  },
  {
    accessorKey: "fac_anulacion",
    header: "Anulacion",
    accessorFn: (row) => `${row.fac_anulacion === "1" ? "ANULADO" : ""}`,
    // size: 450,
  },
  {
    accessorKey: "fcd_precio",
    header: "Subtotal",
    // size: 450,
  },
  {
    accessorKey: "fcd_itbms",
    header: "ITBMS",
    // size: 450,
  },
  {
    accessorKey: "fcd_total",
    header: "TOTAL",
    // size: 450,
  },
];

export const COLUMNS_REPORT_VENTA = [
  {
    accessorKey: "fac_id", //access nested data with dot notation
    header: "N° documento",
    accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
    // size: 20,
  },
  {
    accessorKey: "fac_fecha",
    header: "Fecha",
    // size: 60,
  },
  {
    accessorKey: "cli_nombre",
    header: "Cliente",
    // size: 170,
  },

  {
    accessorKey: "cli_ruc",
    header: "RUC",
    // size: 40,
  },
  {
    accessorKey: "usr_nombre",
    header: "Vendedor",
    // size: 60,
  },
  {
    accessorKey: "fac_caja",
    header: "Caja",
    // size: 450,
  },
  {
    accessorKey: "fac_motivo_anulacion",
    header: "Motivo",
    // size: 450,
  },
  {
    accessorKey: "fac_date_anulacion",
    header: "Fecha de anulacion",
    // size: 450,
  },
  {
    accessorKey: "fac_anulacion",
    header: "Anulacion",
    accessorFn: (row) => `${row.fac_anulacion === "1" ? "ANULADO" : ""}`,
    // size: 450,
  },
  {
    accessorKey: "fcd_precio",
    header: "Subtotal",
    // size: 450,
  },
  {
    accessorKey: "fcd_itbms",
    header: "ITBMS",
    // size: 450,
  },
  {
    accessorKey: "fcd_total",
    header: "TOTAL",
    // size: 450,
  },
];
export const COLUMNS_AP_APARTADO = [
  {
    accessorKey: "ap_docn", //access nested data with dot notation
    header: "N° documento",
    size: 20,
  },
  {
    accessorKey: "dcd_total",
    header: "Monto",
    size: 60,
  },
  {
    accessorKey: "prov_proveedor",
    header: "Proveedor",
    size: 170,
  },

  {
    accessorKey: "ap_fecha",
    header: "Fecha de documento",
    size: 40,
  },
  {
    accessorKey: "ap_fecha_procesado",
    accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.ap_fecha_procesado))}`,
    header: "Fecha de procesado",
    size: 60,
  },
  {
    accessorKey: "ap_descripcion",
    header: "DESCRIPCIÓN",
    size: 450,
  },
];
export const COLUMNS_DC_COMPRA = [
  {
    accessorKey: "dc_docn", //access nested data with dot notation
    header: "N° DOC.",
    size: 80,
    grow: false,
    minSize: 80,
    maxSize: 120,
  },
  {
    accessorKey: "dcd_total",
    header: "MONTO",
    grow: true,
    minSize: 30,
    maxSize: 80,
  },
  {
    accessorKey: "prov_proveedor",
    header: "PROVEEDOR",
    grow: true,
    minSize: 100,
    maxSize: 140,
  },
  {
    accessorKey: "bod_nombre",
    header: "BODEGA",
    grow: true,
    minSize: 100,
    maxSize: 140,
  },
  {
    accessorKey: "com_alias",
    header: "SUCURSAL",
    grow: true,
    minSize: 80,
    maxSize: 120,
  },
  {
    accessorKey: "dc_fecha",
    accessorFn: (row) =>
      `${row.dc_fecha === "0000-00-00 00:00:00" ? "" : moment(row.dc_fecha).format("YYYY-MM-DD")}`,
    header: "F. DOCUMENTO",
    size: 110,
    grow: true,
  },
  {
    accessorKey: "dc_fecha_procesado",
    accessorFn: (row) =>
      `${
        row.dc_fecha_procesado === "0000-00-00 00:00:00"
          ? ""
          : FORMATO_AM_PM(new Date(row.dc_fecha_procesado))
      }`,
    header: "F. PROCESADO",
    size: 110,
    grow: true,
  },
  {
    accessorKey: "dc_descripcion",
    header: "DESCRIPCIÓN",
    size: 240,
    grow: true,
  },
];
export function COLUMNS_DC_COMPRA_DETALLE(deleteRow, onBlurs) {
  return [
    {
      accessorKey: "art_upc", //access nested data with dot notation
      header: "CÓDIGO",
      size: 80,
      minSize: 60,
      grow: false,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 270,
      minSize: 220,
      enableEditing: false,
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.dcd_precio).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "dcd_precio",
      header: "PRECIO",
      size: 40,
      minSize: 40,
      enableEditing: false,
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.dcd_cantidad).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "dcd_cantidad",
      header: "CANTIDAD",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 40,
      minSize: 40,
    },
    {
      accessorKey: "dcd_itbms",
      header: "ITBMS",
      size: 40,
      minSize: 40,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${MONEY_ROUND(cell.row.original.dcd_itbms === "" ? "0.00" : cell.row.original.dcd_itbms)}`}</span>
              {cell.row.original.art_itbm_compra === "0.00" ? (
                <span className="porcent-label-exento">{"Ex"}</span>
              ) : (
                <span className="porcent-label">
                  {(Number(cell.row.original.art_itbm_compra) * 100).toFixed(0) + "%"}
                </span>
              )}
            </Col>
          </Row>
        );
      },
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${MONEY_ROUND(cell.row.original.dcd_total)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "dcd_total",
      header: "TOTAL",
      size: 60,
      minSize: 40,
      enableEditing: false,
    },
  ];
}
export function COLUMNS_BODEGAS() {
  return [
    {
      accessorKey: "bod_nombre",
      header: "BODEGA",
      // size: 350,
      enableEditing: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "inv_qty", //normal accessorKey
      header: "EXISTENCIA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 100,
    },
    //     {
    //   accessorKey: "inv_qty", //normal accessorKey
    //   header: "MONTO",
    //   accessorFn: (row) => `${parseFloat(row.list_monto).toFixed(2)}`,
    //   muiTableHeadCellProps: {
    //     align: 'center',
    //   },
    //   muiTableBodyCellProps: {
    //     align: 'center',
    //   },
    //   size: 100,
    // },
  ];
}

export function COLUMNS_LISTA_FPAGO() {
  return window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left">
                <Col xs={12}>
                  <span className="label-fpago">
                    <b>
                      {" "}
                      {cell.row.original.list_fpagoName} :{" "}
                      {parseFloat(cell.row.original.list_monto).toFixed(2)}
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          accessorKey: "list_fpagoName",
          header: "FORMA DE PAGO",
          grow: true,
          enableEditing: false,
        },
        {
          accessorKey: "list_monto", //normal accessorKey
          header: "MONTO",
          accessorFn: (row) => `${parseFloat(row.list_monto).toFixed(2)}`,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ]
    : [
        {
          accessorKey: "list_fpagoName",
          header: "FORMA DE PAGO",
          size: 350,
          enableEditing: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "list_monto", //normal accessorKey
          header: "MONTO",
          accessorFn: (row) => `${parseFloat(row.list_monto).toFixed(2)}`,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          size: 100,
        },
      ];
}

export function COLUMNS_LISTA_ANULACION(setTabAnular, setFormAnulacion) {
  return window.innerWidth <= 611
    ? [
        {
          accessorKey: "fac_id",
          header: "ANULACIÓN",
          grow: true,
          // size:210,
          enableEditing: false,
          Cell: ({ cell }) => {
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b> # FACTURA : {cell.row.original.fac_id.toString().padStart(10, "0")}</b>
                  </span>
                  <br></br>
                  <span>
                    NOMBRE :{" "}
                    {cell.row.original.cli_ruc !== ""
                      ? cell.row.original.cli_nombre + " " + cell.row.original.cli_ruc
                      : cell.row.original.cli_nombre}
                  </span>
                  <br></br>
                  <span>FECHA : {FORMATO_AM_PM(new Date(cell.row.original.fac_fecha))}</span>
                  <br></br>
                  <span className="float-end label-money">
                    <b>
                      TOTAL : $
                      {new Decimal(cell.row.original.fac_total).toFixed(2)}
                    </b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
        },
      ]
    : [
        {
          accessorKey: "fac_id",
          header: "# FACTURA",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          size: 70,
          // accessorFn: (row) => `${<Label>{row.fac_id.toString().padStart(10, "0")}</Label>}`,
          Cell: ({ row, cell }) => {
            return (
              <Box className="d-flex">
                
                <Label className="class-btn-factura fw-bold text-dark">
                  {row.original.fac_id.toString().padStart(10, "0")}
                </Label>
              </Box>
            );
          },
        },
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) =>
            `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
          header: "NOMBRE",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "fac_fecha",
          accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.fac_fecha))}`,
          header: "FECHA",
          size: 70,
          enableGlobalFilter: false,
          enableFilters: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          size: 70,
          accessorKey: "fac_total",
          header: "MONTO",
          accessorFn: (row) => `$${Number(row.fac_total).toFixed(2)} `,
        },
      ];
}

export function COLUMNS_LISTA_FACTURA(selectItemFCopia, getDetailItem, SetOpenDetailCopia,usr_print) {
  //tipo 0 => recibo, tipo 1 =>electronica
  return window.innerWidth <= 611
    ? [
      {
          header: "ARTÍCULO",
          accessorFn: (row) =>
            `${row.fac_id} ${row.cli_nombre} ${row.fac_fecha} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b># FACTURA {row.original.fac_tipodocumento ==="01"?highlightText(row.original.fac_id.toString().padStart(10, "0"), search):"NC: " +row.original.fac_doc_nc } </b>
                  </span>
                  <br></br>
                  <span>CLIENTE : {highlightText(row.original.cli_nombre, search)}</span>
                  <br></br>
                  <span>MONTO : $ {highlightText(Number(row.original.fac_total).toFixed(2), search)}</span>
                  <br></br>
                  <span>FECHA : {highlightText(FORMATO_AM_PM(new Date(row.original.fac_fecha)), search) } </span> <br></br>
                  <span>TIPO DOCUMENTO : {row.original.fac_tipodocumento ==="01"?"FACTURA DE OPERACIÓN INTERNA":"NOTA DE CRÉDITO REFERENTE A UNA FE :"+ row.original.fac_doc_nc} </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
        {
          accessorKey: "fac_fecha",
          header: "OPCIONES",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          size: 10,
          Cell: ({ row, cell }) => {
            return (
              <Row>
                <Col xs={12} className="col-btn-reportes">
                  {(usr_print ==="2"||usr_print ==="4")&& <MDBIcon
                    fas
                    icon="print"
                    className="me-3 class-btn-factura-datatable icon-size"
                    onClick={() =>
                      selectItemFCopia({
                        data: row.original,
                        tipo: row.original.fac_recibo,
                        print_type: "recibo",
                      })
                    }
                  />}
                  {row.original.fac_recibo === "1" ? (
                    <MDBIcon
                      fas
                      icon="file-pdf"
                      className="me-3 class-btn-factura-datatable icon-size"
                      onClick={() =>
                        selectItemFCopia({
                          data: row.original,
                          tipo: row.original.fac_recibo,
                          print_type: "pdf",
                        })
                      }
                    />
                  ) : null}
                  <MDBIcon
                    fas
                    icon="search"
                    className="me-3 class-btn-factura-datatable icon-size"
                    onClick={() => {
                      getDetailItem({ data: row.original });
                      SetOpenDetailCopia(true);
                    }}
                  />
                </Col>
              </Row>
            );
            //     return <Box className="d-flex">

            // </Box>
          },
        },
      ]
    : [
        {
          accessorKey: "fac_id",
          header: "# FACTURA",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          size: 70,
          Cell: ({ row, cell }) => {
            return (
              <Row>
                <Col xs ={6}>
                <Box className="d-flex">
               {(usr_print ==="2"||usr_print ==="4")&&   <MDBIcon
                  fas
                  icon="print"
                  className="me-3 class-btn-factura-datatable icon-size"
                  onClick={() =>
                    selectItemFCopia({
                      data: row.original,
                      tipo: row.original.fac_recibo,
                      print_type: "recibo",
                    })
                  }
                />
                }
                {row.original.fac_recibo === "1" ? (
                  <MDBIcon
                    fas
                    icon="file-pdf"
                    className="me-3 class-btn-factura-datatable icon-size"
                    onClick={() =>
                      selectItemFCopia({
                        data: row.original,
                        tipo: row.original.fac_recibo,
                        print_type: "pdf",
                      })
                    }
                  />
                ) : null}
                <MDBIcon
                  fas
                  icon="search"
                  className="me-3 class-btn-factura-datatable icon-size"
                  onClick={() => {
                    getDetailItem({ data: row.original });
                    SetOpenDetailCopia(true);
                  }}
                />
                
              </Box></Col>
                <Col xs ={6}><Label className="class-btn-factura fw-bold text-dark">
                  {row.original.fac_tipodocumento === "01"? row.original.fac_id.toString().padStart(10, "0"):"NC: " +row.original.fac_doc_nc }
                </Label></Col>
              </Row>
              
            );
          },
        },
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) =>
            `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
          header: "NOMBRE",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "fac_total",
          accessorFn: (row) =>`$ ${Number(row.fac_total).toFixed(2)}`,
          header: "MONTO",
           size: 50,
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "fac_fecha",
          accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.fac_fecha))}`,
          header: "FECHA",
          size: 70,
          enableGlobalFilter: false,
          enableFilters: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "fac_tipodocumento",
          accessorFn: (row) => `${row.fac_tipodocumento ==="01"?"FACTURA DE OPERACIÓN INTERNA":"NOTA DE CRÉDITO REFERENTE A UNA FE: " +row.fac_doc_nc }`,
          header: "TIPO DOCUMENTO",
          size: 70,
          enableGlobalFilter: false,
          enableFilters: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}

export function COLUMNS_LISTA_ITEMS_BODEGA() {
  return [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      enableGlobalFilter: true,
    },
    {
      accessorKey: "art_referencia",
      header: "REFERENCIA",
      size: 75,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: true,
    },
    {
      accessorKey: "art_descripcion", //normal accessorKey
      header: "DESCRIPCIÓN",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      enableGlobalFilter: true,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "mar_descripcion", //normal accessorKey
      header: "MARCA",
      size: 50,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "cat_descripcion", //normal accessorKey
      header: "CATEGORIA",
      size: 80,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "inv_qty", //normal accessorKey
      header: "EXISTENCIA",
      size: 70,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "bod_nombre", //normal accessorKey
      header: "BODEGA",
      size: 50,
    },
    {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableGlobalFilter: false,
      accessorKey: "com_alias", //normal accessorKey
      header: "SUCURSAL",
      size: 80,
    },
  ];
}
const highlightText = (text, search) => {
  if (!search) return text;

  const regex = new RegExp(`(${search})`, "gi");
  return text.split(regex).map((part, i) =>
    regex.test(part) ? (
      <mark key={i} style={{ backgroundColor: "yellow", padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};
export function COLUMNS_LISTA_ITEMS() {
  return window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",
          accessorFn: (row) =>
            `${row.art_upc} ${row.art_referencia} ${row.art_descripcion} ${row.mar_descripcion} ${row.art_precio}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>{highlightText(row.original.art_upc, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    REFERENCIA: {highlightText(row.original.art_referencia, search)}
                  </span>

                  <br />
                  <span className="font-w-14">
                    DESCRIPCIÓN: {highlightText(row.original.art_descripcion, search)}
                  </span>

                  <br />
                  <span className="font-w-14">
                    MARCA: {highlightText(row.original.mar_descripcion, search)}
                  </span>
 <br />
                  <span className="font-w-14 float-end label-money">
                    <b>PRECIO: ${highlightText(row.original.art_precio, search)}</b>
                  </span>
                </Col>
              </Row>
            );
          },

          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          size: 70,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          enableGlobalFilter: true,
        },
        {
          accessorKey: "art_referencia",
          header: "REFERENCIA",
          size: 70,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          enableGlobalFilter: true,
        },
        {
          accessorKey: "art_descripcion", //normal accessorKey
          header: "DESCRIPCIÓN",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
          enableGlobalFilter: true,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_costo", //normal accessorKey
          header: "COSTO",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_precio", //normal accessorKey
          header: "PRECIO",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_precio2", //normal accessorKey
          header: "PRECIO 2",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "art_precio3", //normal accessorKey
          header: "PRECIO 3",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "itbm_descripcion", //normal accessorKey
          header: "ITBMS",
          size: 50,
        },
        {
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableGlobalFilter: false,
          accessorKey: "mar_descripcion", //normal accessorKey
          header: "MARCA",
          size: 50,
        },
      ];
}

export const COLUMNS_COT_COTIZACION =  window.innerWidth <= 611
    ? [
        {
          header: "COTIZACIÓN",
          accessorFn: (row) =>
          `${row.art_upc} ${row.cli_nombre} ${row.cli_ruc} ${row.com_alias} ${row.cot_fecha} ${row.cotd_total}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># COTIZACIÓN: {highlightText(row.original.cot_id, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    CLIENTE: {highlightText(row.original.cli_nombre, search)} {highlightText(row.original.cli_ruc, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    SUCURSAL: {highlightText(row.original.com_alias, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    FECHA: {highlightText(row.original.cot_fecha, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14 float-end label-money">
                    <b>
                      TOTAL:{" "}
                      {highlightText(
                        MONEY_ROUND(row.original.cotd_total),
                        search
                      )}
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "cot_id", //access nested data with dot notation
    header: "# COTIZACIÓN",
    size: 150,
    minSize: 150,
    maxSize: 250,
    grow: false,
  },
  {
    accessorKey: "cli_nombre",
    accessorFn: (row) => `${row.cli_nombre + " / " + row.cli_ruc}`,
    header: "CLIENTE",
    size: 600,
    minSize: 600,
    maxSize: 700,
    grow: false,
    Edit: () => null,
    enableEditing: false,
  },
  {
    accessorKey: "com_alias",
    header: "SUCURSAL",
    size: 220,
    minSize: 220,
    maxSize: 250,
    grow: false,
    Edit: () => null,
    enableEditing: false,
  },
  {
    accessorKey: "cot_fecha", //normal accessorKey
    header: "FECHA",
    size: 120,
    minSize: 120,
    maxSize: 140,
    grow: false,
    Edit: () => null,
    enableEditing: false,
  },
  {
    accessorKey: "cotd_total",
    header: "MONTO",
    accessorFn: (row) => `$ ${MONEY_ROUND(row.cotd_total)}`,
    size: 120,
    minSize: 120,
    maxSize: 140,
    grow: false,
    Edit: () => null,
    enableEditing: false,
  },
];

export function COLUMNS_FAC_FACTURA_DETALLE2(deleteRow, onBlurs) {
  return [
    {
      accessorKey: "fac_id",
      // size: 60,
      // minSize:40,
      header: "",
      enableHiding: false,
      enableEditing: false,
      columnVisibility: false,
      Cell: ({ row, cell }) => {
        return (
          <Box className="width-box-delete2">
            <Row>
              <Col xs={6}>
                <Label>ARTICULO</Label>
              </Col>
              <Col xs={2}>
                <Label>CANT</Label>
              </Col>
              <Col xs={2}>
                <Label>PRECIO</Label>
              </Col>
              <Col xs={2}>
                <Label>TOTAL</Label>
              </Col>
            </Row>
            <Row>{}</Row>
            <IconButton color="error" onClick={() => deleteRow(row)}>
              <DeleteIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];
}

export function COLUMNS_ORDENES_DETALLE_RESTAURANTE(usr_precio) {
  return [
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 200,
      minSize: 200,
      id: "art_descripcion",
      grow: true,
      Edit: () => null,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={2}>
              {cell.row.original.ordd_entregado === "0" && (
                <img src={COOK_MAN} className="img-cook" alt="..." />
              )}
            </Col>
            <Col xs={10}>
              <span>{cell.row.original.art_descripcion}</span>
            </Col>
          </Row>
        );
      },
    },
    {
      accessorKey: "ordd_precio",
      header: "PRECIO",
      accessorFn: (row) => `$${parseFloat(row.ordd_precio).toFixed(2)}`,
      size: 35,
      minSize: 35,
      grow: true,
      // Edit: () => null,
      enableEditing: false,
    },
    {
      accessorKey: "ordd_cantidad",
      accessorFn: (row) => `${parseFloat(row.ordd_cantidad).toFixed(2)}`,
      header: "CANTIDAD",
      size: 45,
      grow: true,
      minSize: 45,
    },
    {
      accessorFn: (row) => `$${roundNumber(Number(row.ordd_total), 3).toFixed(3)}`,
      accessorKey: "ordd_total",
      header: "TOTAL",
      size: 35,
      minSize: 35,
      maxSize: 35,
      grow: true,
      Edit: () => null,
      enableEditing: false,
    },
  ];
}
export function COLUMNS_FAC_FACTURA_DETALLE_ENABLE_ONLY_DESCUENTO(usr_precio) {
  return [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      minSize: 160,
      grow: true,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      minSize: 400,
      maxSize: 500,
      grow: true,
      enableEditing: false,
    },
    {
      accessorKey: "fcd_precio",
      header: "PRECIO",
      accessorFn: (row) =>
        `${new Decimal(row.fcd_precio).toFixed(2)}`,
      minSize: 60,
      maxSize: 80,
      grow: false,
      enableEditing: false,
    },
    {
      accessorKey: "fcd_cantidad",
      accessorFn: (row) =>
        `${new Decimal(row.fcd_cantidad).toFixed(2)}`,
      header: "CANTIDAD",
      grow: false,
      minSize: 80,
      enableEditing: false,
    },
    {
      accessorKey: "fcd_descuento",
      accessorFn: (row) =>
        `${parseFloat(
          row.fcd_descuento === ""
            ? "0.00"
            : MONEY_ROUND(row.fcd_descuento)
        ).toFixed(2)}`,
      header: "DESC. %",
      size: 80,
      enableEditing: false,
      minSize: 80,
      grow: false,
      Cell: ({ cell }) => {
        return (
          <div className="text-center">
            <span>{`${MONEY_ROUND(cell.row.original.fcd_descuento === "" ? "0.00" : cell.row.original.fcd_descuento)}`}</span>
            {Number(cell.row.original.fcd_descuento) === Number("0.00") ? null : (
              <span className="porcent-label">
                {Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "fcd_descuento_number",
      header: "DESC. NÚMERO",
      size: 60,
      grow: true,
      minSize: 60,
      enableEditing: true,
    },
    {
      accessorKey: "fcd_itbms",
      header: "ITBMS",
      minSize: 90,
      maxSize: 110,
      id: "fcd_itbms",
      grow: false,
      Edit: () => null,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <>
            <span>{`${MONEY_ROUND(
              cell.row.original.fcd_itbms === "" ? "0.00" : cell.row.original.fcd_itbms
            )}`}</span>
            {cell.row.original.art_itbm_venta === "0.00" ? (
              <span className="porcent-label-exento">{"Ex"}</span>
            ) : (
              <span className="porcent-label">
                {(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}
              </span>
            )}
          </>
        );
      },
    },
    {
      accessorFn: (row) =>
        `${MONEY_ROUND(row.fcd_total)}`,
      accessorKey: "fcd_total",
      header: "TOTAL",
      minSize: 70,
      maxSize: 110,
      grow: false,
      Edit: () => null,
      enableEditing: false,
    },
  ];
}
export function COLUMNS_FAC_FACTURA_DETALLE_COPIA() {
  return window.innerWidth <= 611
    ? [

{
          header: "ARTÍCULO",
          accessorFn: (row) =>
            `${row.art_upc} ${row.art_categoria} ${row.art_descripcion} ${row.art_marca} ${row.art_linea_roja} ${row.inv_qty} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
                            <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b> {highlightText(row.original.art_upc, search)}</b>
                  </span>
                  <br></br>
                  <span>{highlightText(row.original.fcd_art_descripcion, search)}</span>
                  <br></br>
                  {Number(row.original.fcd_descuento) === Number("0.00") ? ("Desc.") : (
                    <span className="porcent-label">
                      {" "}
                      Desc. {MONEY_ROUND(row.original.fcd_descuento)}
                    </span>
                  )}{" "}
        
                  <br></br>
                  <span>{`I.T.B.M.S. = ${MONEY_ROUND(row.original.fcd_itbms === "" ? "0.00" : row.original.fcd_itbms)}`}
                    {row.original.art_itbm_venta === "0.00" ? (<span className="porcent-label-exento">{"Ex"}</span>) : (
                          <span className="porcent-label">
                            {(Number(row.original.art_itbm_venta) * 100).toFixed(0) + "%"}
                          </span>
                        )}</span>
                  <span className="float-end label-money">
                    <b>
                      {row.original.fcd_precio} x {row.original.fcd_cantidad} ={" "}
                      {highlightText(MONEY_ROUND(row.original.fcd_total), search) }
                    </b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          minSize: 70,
          grow: false,
          enableEditing: false,
        },
        {
          accessorKey: "fcd_art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 300,
          maxSize: 350,
          grow: false,
        },
        {
          accessorKey: "fcd_precio",
          header: "PRECIO",
          accessorFn: (row) =>
            `${new Decimal(row.fcd_precio).toFixed(2)}`,
          minSize: 110,
          maxSize: 110,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
        },
        {
          accessorKey: "fcd_cantidad",
          accessorFn: (row) =>
            `${new Decimal(row.fcd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          muiTableBodyCellProps: {
            align: "center",
          },
          minSize: 120,
          maxSize: 120,
        },
        {
          accessorKey: "fcd_descuento",
          accessorFn: (row) =>
            `${MONEY_ROUND(
              row.fcd_descuento === ""
                ? "0.00"
                : row.fcd_descuento )}`,
          header: "DESC. %",
          size: 100,
          enableEditing: false,
          minSize: 100,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
        },
        {
          accessorKey: "fcd_itbms",
          accessorFn: (row) =>
            `${MONEY_ROUND(row.fcd_itbms)}`,
          header: "ITBMS",
          minSize: 110,
          maxSize: 110,
          id: "fcd_itbms",
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
        {
          accessorFn: (row) =>
            `${MONEY_ROUND(row.fcd_total)}`,
          accessorKey: "fcd_total",
          header: "TOTAL",
          minSize: 70,
          maxSize: 110,
          muiTableBodyCellProps: {
            align: "center",
          },
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];
}
export function COLUMNS_FAC_FACTURA_DETALLE(usr_precio) {
  return window.innerWidth <= 611
    ? [
        {
          accessorKey: "art_upc",
          header: "ARTÍCULO",
          grow: true,
          enableEditing: false,
          Cell: ({ cell }) => {
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b> {cell.row.original.art_upc}</b>
                  </span>
                  <br></br>
                  <span>{cell.row.original.art_descripcion}</span>
                  <br></br>
                  {Number(cell.row.original.fcd_descuento) === Number("0.00") ? (
                    "Desc."
                  ) : (
                    <span className="porcent-label">
                      {" "}
                      Desc. {Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}
                    </span>
                  )}{" "}
                  <br></br>
                  <span>{`I.T.B.M.S. = ${MONEY_ROUND(cell.row.original.fcd_itbms === "" ? "0.00" : cell.row.original.fcd_itbms)} `}</span>
                  {cell.row.original.art_itbm_venta === "0.00" ? (<span className="porcent-label-exento">{"Ex"}</span>) : (
                    <span className="porcent-label">
                      {(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}
                    </span>
                  )}
                  <br></br>
                  <span className="float-end label-money">
                    <b>
                      {Number(cell.row.original.fcd_precio).toFixed(2)} x {cell.row.original.fcd_cantidad} ={" "}
                      {MONEY_ROUND(cell.row.original.fcd_total)}
                    </b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 400,
          maxSize: 500,
          grow: true,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_precio",
          header: "PRECIO",
          accessorFn: (row) =>`${new Decimal(row.fcd_precio).toFixed(2)}`,
          minSize: 60,
          maxSize: 80,
          grow: false,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_cantidad",
          accessorFn: (row) =>`${new Decimal(row.fcd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          columnVisibility: false,
          minSize: 80,
          maxSize: 100,
        },
        {
          accessorKey: "fcd_descuento",
          accessorFn: (row) =>`${row.fcd_descuento === ""? "0.00": MONEY_ROUND(row.fcd_descuento)}`,
          header: "DESC. %",
          size: 80,
          enableEditing: false,
          minSize: 80,
          grow: false,
          Cell: ({ cell }) => {
         
            return (
              <div className="text-center">
                <span>{`${MONEY_ROUND(cell.row.original.fcd_descuento === "" ? "0.00" : cell.row.original.fcd_descuento)}`}</span>
                {Number(cell.row.original.fcd_descuento) === Number("0.00") ? null : (
                  <span className="porcent-label">
                    {Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}
                  </span>
                )}
              </div>
            );
          },
        },
        {
          accessorKey: "fcd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
        },
      ]
    : [
        {
          accessorKey: "art_upc",
          header: "CÓDIGO",
          minSize: 160,
          grow: true,
          enableEditing: false,
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 400,
          maxSize: 500,
          grow: true,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_precio",
          header: "PRECIO",
          accessorFn: (row) =>`${new Decimal(row.fcd_precio).toFixed(2)}`,
          minSize: 60,
          maxSize: 80,
          grow: false,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "fcd_cantidad",
          accessorFn: (row) =>`${new Decimal(row.fcd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          minSize: 80,
          maxSize: 100,
        },
        {
          accessorKey: "fcd_descuento",
          accessorFn: (row) =>`${row.fcd_descuento === "" ? "0.00" : MONEY_ROUND(row.fcd_descuento)}`,
          header: "DESC. %",
          size: 80,
          enableEditing: false,
          minSize: 80,
          grow: false,
          Cell: ({ cell }) => {
          //     console.log(new Decimal(cell.row.original.fcd_descuento).toNumber())
            return (
              <div className="text-center">
                <span>{`${cell.row.original.fcd_descuento === "" ? "0.00" : MONEY_ROUND(cell.row.original.fcd_descuento)}`}</span>
                {Number(cell.row.original.fcd_descuento) === Number("0.00") ? null : (
                  <span className="porcent-label">
                    {Number(cell.row.original.fcd_descuento_number).toFixed(0) + "%"}
                  </span>
                )}
              </div>
            );
          },
        },
        {
          accessorKey: "fcd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
        },
        {
          accessorKey: "fcd_itbms",
          header: "ITBMS",
          minSize: 90,
          maxSize: 110,
          id: "fcd_itbms",
          grow: false,
          Edit: () => null,
          enableEditing: false,
          Cell: ({ cell }) => {
            return (
              <><span>{`${MONEY_ROUND(cell.row.original.fcd_itbms === "" ? "0.00" : cell.row.original.fcd_itbms)}`}</span>
                {cell.row.original.art_itbm_venta === "0.00" ? (<span className="porcent-label-exento">{"Ex"}</span>) : (
                  <span className="porcent-label">{(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}</span>
                )}
              </>);
          },
        },
        {
          accessorFn: (row) =>
            `${MONEY_ROUND(row.fcd_total)}`,
          accessorKey: "fcd_total",
          header: "TOTAL",
          minSize: 70,
          maxSize: 110,
          grow: false,
          Edit: () => null,
          enableEditing: false,
        },
      ];
}

export function COLUMNS_COTD_COOTIZACION_DETALLE(usr_precio) {
    return window.innerWidth <= 611
    ? [
        {
          accessorFn: (row) =>`${row.art_upc} ${row.cotd_precio} ${row.art_descripcion} ${row.cotd_cantidad} ${row.cotd_descuento}`,
          accessorKey: "art_upc",
          header: "ARTÍCULO",
          // minSize:160,
          grow: true,
          enableEditing: false,
          Cell: ({ row,table }) => {
             const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-start d-content">
                <Col xs={12} className="col-sin-padding text-left font-size-dt">
                  <span className="label-art-upc">
                    <b> {highlightText(row.original.art_upc, search)}</b>
                  </span>
                  <br></br>
                  <span>{highlightText(row.original.art_descripcion, search)}</span>
                  <br></br>
                  {Number(row.original.cotd_descuento) === Number("0.00") ? (
                    "Desc."
                  ) : (
                    <span className="porcent-label">
                      {" "}
                      Desc. {Number(row.original.cotd_descuento_number).toFixed(0) + "%"}
                    </span>
                  )}{" "}
                  <br></br>
                  <span>{`I.T.B.M.S. = ${MONEY_ROUND( row.original.cotd_itbms === "" ? "0.00" : row.original.cotd_itbms)}`}</span>
                  {row.original.art_itbm_venta === "0.00" ? (
                    <span className="porcent-label-exento">{"Ex"}</span>
                  ) : (
                    <span className="porcent-label">
                      {(Number(row.original.art_itbm_venta) * 100).toFixed(0) + "%"}
                    </span>
                  )}
                  <br></br>
                  <span className="float-end label-money">
                    <b>
                      {Number(row.original.cotd_precio).toFixed(2)} x {row.original.cotd_cantidad} ={" "}
                      {MONEY_ROUND(row.original.cotd_total) }
                    </b>
                    <br></br>
                  </span>
                </Col>
              </Row>
            );
          },
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          minSize: 400,
          maxSize: 500,
          grow: true,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "cotd_precio",
          header: "PRECIO",
          accessorFn: (row) =>
            `${new Decimal(row.cotd_precio).toFixed(2)}`,
          minSize: 60,
          maxSize: 80,
          grow: false,
          enableEditing: usr_precio === "1" ? true : false,
        },
        {
          accessorKey: "cotd_cantidad",
          accessorFn: (row) =>
            `${new Decimal(row.cotd_cantidad).toFixed(2)}`,
          header: "CANTIDAD",
          grow: false,
          columnVisibility: false,
          minSize: 80,
          maxSize: 100,
        },
        {
          accessorKey: "cotd_descuento",
          accessorFn: (row) =>
            `${MONEY_ROUND(
              row.cotd_descuento === ""
                ? "0.00"
                : row.cotd_descuento)
            }`,
          header: "DESC. %",
          size: 80,
          enableEditing: false,
          minSize: 80,
          grow: false,
          Cell: ({ cell }) => {
            return (
              <div className="text-center">
                <span>{`${MONEY_ROUND(
                  cell.row.original.cotd_descuento === "" ? "0.00" : cell.row.original.cotd_descuento
                )}`}</span>
                {Number(cell.row.original.cotd_descuento) === Number("0.00") ? null : (
                  <span className="porcent-label">
                    {Number(cell.row.original.cotd_descuento_number).toFixed(0) + "%"}
                  </span>
                )}
              </div>
            );
          },
        },
        {
          accessorKey: "cotd_descuento_number",
          header: "DESC. NÚMERO",
          size: 60,
          grow: true,
          minSize: 60,
        },
      ]
    :  [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      size: 100,
      minSize: 80,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 230,
      minSize: 200,
      enableEditing: false,
    },
    {
      accessorFn: (row) =>
        `${new Decimal(row.cotd_precio).toFixed(2)}`,
      accessorKey: "cotd_precio",
      header: "PRECIO",
      size: 60,
      minSize: 60,
      enableEditing: usr_precio === "1" ? true : false,
    },

    {
      accessorFn: (row) => `${new Decimal(row.cotd_cantidad).toFixed(2)}`,
      accessorKey: "cotd_cantidad",
      header: "CANTIDAD",
      size: 60,
      minSize: 60,
    },
    {
      accessorKey: "cotd_descuento",
      accessorFn: (row) =>`${parseFloat(row.cotd_descuento === ""? "0.00":MONEY_ROUND(row.cotd_descuento)).toFixed(2)}`,
      header: "DESC. %",
      size: 60,
      grow: true,
      minSize: 60,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <div className="text-center">
            <span>{`${MONEY_ROUND(cell.row.original.cotd_descuento === "" ? "0.00" : cell.row.original.cotd_descuento)}`}</span>
            {Number(cell.row.original.cotd_descuento) === Number("0.00") ? null : (
              <span className="porcent-label">
                {Number(cell.row.original.cotd_descuento_number).toFixed(0) + "%"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "cotd_descuento_number",
      header: "DESC. NÚMERO",
      size: 60,
      grow: true,
      minSize: 60,
    },
    {
      accessorKey: "cotd_itbms",
      header: "ITBMS",
      size: 60,
      minSize: 60,
      enableEditing: false,
      Edit: () => null,
      Cell: ({ cell }) => {
        return (
          <>
            <span>{`${ MONEY_ROUND(cell.row.original.cotd_itbms === "" ? "0.00" : cell.row.original.cotd_itbms)}`}</span>
            {cell.row.original.art_itbm_venta === "0.00" ? (
              <span className="porcent-label-exento">{"Ex"}</span>
            ) : (
              <span className="porcent-label">
                {(Number(cell.row.original.art_itbm_venta) * 100).toFixed(0) + "%"}
              </span>
            )}
          </>
        );
      },
    },
    {
      accessorFn: (row) =>`${MONEY_ROUND(row.cotd_total)}`,
      accessorKey: "cotd_total",
      header: "TOTAL",
      size: 60,
      minSize: 60,
      muiTableBodyCellProps: {
        align: "center",
      },
      enableEditing: false,
      Edit: () => null,
    },
  ];
}

export function COLUMNS_LISTA_CREDITOS() {
  return window.innerWidth <= 611? [
    {
      header: "CLIENTES",
      accessorFn: (row) =>`${row.cli_nombre} ${row.cli_ruc} ${row.crd_monto_c} ${row.crp_monto_p} `,
      Cell: ({ row, table }) => {
        const search = table.getState().globalFilter ?? "";
        return (
          <Row className="text-left">
            <Col xs={12} className="font-size-dt">
              <span className="label-art-upc">
                <b>{highlightText(row.original.cli_nombre, search)}</b>
              </span>
              <br></br>
              <span>RUC : {highlightText(row.original.cli_ruc, search)}</span>
              <br></br>
              <span>TOTAL : {highlightText(Number(row.original.crd_monto_c).toFixed(2), search)}</span>
              <br></br>
              <span>SALDO ADEUDADO : {`${(Number(row.original.crd_monto_c) - Number(row.original.crp_monto_p)).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      filterFn: "fuzzy",
      enableGlobalFilter: true,
      enableEditing: false,
      grow: true,
      }
    ]
    :  [
    {
      accessorKey: "cli_nombre",
      accessorFn: (row) =>
        `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
      header: "NOMBRE",
      enableGlobalFilter: true,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },
    {
      accessorKey: "cli_ruc",
      accessorFn: (row) => `${row.cli_dv !== "" ? row.cli_ruc + " DV " + row.cli_dv : row.cli_ruc}`,
      header: "RUC",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crd_monto_c",
      accessorFn: (row) => `${Number(row.crd_monto_c).toFixed(2)}`,
      header: "TOTAL",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crp_monto_p",
      accessorFn: (row) => `${(Number(row.crd_monto_c) - Number(row.crp_monto_p)).toFixed(2)}`,
      header: "SALDO ADEUDADO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_CREDITOS_PAGO() {
  return [
    {
      accessorKey: "fac_id",
      header: "N° FACTURA",
      accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_nombre",
      header: "CLIENTE",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_ruc",
      header: "RUC",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crp_monto",
      header: "MONTO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crp_fecha))}`,
      accessorKey: "crp_fecha",
      header: "FECHA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crp_fecha_delete))}`,
      accessorKey: "crp_fecha_delete",
      header: "ELIMINADO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_CREDITOS() {
  return [
    {
      accessorKey: "fac_id",
      header: "N° FACTURA",
      accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_nombre",
      header: "CLIENTE",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "cli_ruc",
      header: "RUC",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crd_monto",
      header: "MONTO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crd_fecha))}`,
      accessorKey: "crd_fecha",
      header: "FECHA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_LISTA_CREDITOS_PAGO() {
  return window.innerWidth <= 611
    ? [{
          header: "ABONOS",
          accessorFn: (row) =>`${row.crp_id} ${row.crp_monto} ${row.crp_fecha}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>N° RECIBO: {highlightText(row.original.crp_id.toString().padStart(10, "0"), search)}</b>
                  </span>
                  <br></br>
                  <span>MONTO ABONADO : {highlightText(FORMATO_AM_PM(new Date(row.original.crp_monto)), search)} </span>
                  <br></br>
                  <span>FECHA : {highlightText(FORMATO_AM_PM(new Date(row.original.crp_fecha)), search)}</span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        }
      ]: [
    {
      accessorKey: "crp_id",
      header: "N° RECIBO",
      accessorFn: (row) => `${row.crp_id.toString().padStart(10, "0")}`,
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crp_monto",
      header: "MONTO ABONADO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.crp_fecha))}`,
      accessorKey: "crp_fecha",
      header: "FECHA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_LISTA_CREDITOS_DETALLE(printFac) {
  return window.innerWidth <= 611
    ? [{
          header: "N° FACTURA",
          accessorFn: (row) =>`${row.fac_id} ${row.fac_fecha} ${row.crd_monto_c} ${row.crp_monto_p} ${row.crp_monto_s}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>N° FACTURA: {highlightText(row.original.fac_id.toString().padStart(10, "0"), search)}</b>
                  </span>
                  <br></br>
                  <span>FECHA : {highlightText(FORMATO_AM_PM(new Date(row.original.fac_fecha)), search)} </span>
                  <br></br>
                  <span>TOTAL : {highlightText(row.original.crd_monto_c, search)}</span>
                  <br></br>
                  <span>MONTO PAGADO : {highlightText(row.original.crp_monto_p, search)}</span>
                  <br></br>
                  <span>SALDO : {highlightText((Number(row.original.crd_monto_c) - Number(row.original.crp_monto_p)).toFixed(2), search)}</span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        }
      ]: [
    {
      accessorKey: "fac_id",
      // accessorFn: (row) => `${row.fac_id.toString().padStart(10, "0")}`,
      header: "N° FACTURA",
      enableGlobalFilter: true,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
      Cell: ({ row, cell }) => {
        return (
          <Box className="d-flex">
            <MDBIcon
              fas
              icon="print"
              className="me-3 class-btn-factura-datatable"
              onClick={() =>
                printFac({
                  data: row.original,
                  tipo: row.original.fac_recibo,
                  print_type: "recibo",
                })
              }
            />
            {row.original.fac_recibo === "1" ? (
              <MDBIcon
                fas
                icon="file-pdf"
                className="me-3 class-btn-factura-datatable"
                onClick={() =>
                  printFac({ data: row.original, tipo: row.original.fac_recibo, print_type: "pdf" })
                }
              />
            ) : null}
            <Label className="class-btn-factura">
              {row.original.fac_id.toString().padStart(10, "0")}
            </Label>
          </Box>
        );
      },
    },
    {
      accessorKey: "fac_fecha",
      accessorFn: (row) => `${FORMATO_AM_PM(new Date(row.fac_fecha))}`,
      header: "FECHA FACTURA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crd_monto_c",
      header: "TOTAL",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "crp_monto_p",
      header: "MONTO PAGADO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorFn: (row) => `${(Number(row.crd_monto_c) - Number(row.crp_monto_p)).toFixed(2)}`,
      accessorKey: "crd_monto_s",
      header: "SALDO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}

export function COLUMNS_LISTA_ORDENES_NORMAL() {
  return window.innerWidth <= 611
    ? [
                  {
          header: "ORDENES",
          accessorFn: (row) =>
            `${row.ord_identificador} ${row.usr_nombre} ${row.cli_nombre} ${row.ord_fecha} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b># ORDEN: {highlightText(row.original.ord_identificador, search)}</b>
                  </span>
                  <br></br>
                  <span>CAJA : {highlightText(row.original.usr_nombre, search)}</span>
                  <br></br>
                  <span>CLIENTE : {highlightText(row.original.cli_nombre, search)}</span>
                  <br></br>
                  <span>FECHA : {highlightText(row.original.ord_fecha !== "0000-00-00 00:00:00" ? highlightText(FORMATO_AM_PM(new Date(row.original.ord_fecha)), search):"") } </span>
                  <br></br>
                  <span className="float-end label-money"><b>{" "}
                    TOTAL :{" "}
                    {MONEY_ROUND(row.original.ordd_total)}</b>
                    
                  </span>{" "}
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "ord_identificador",
          accessorFn: (row) => `${row.ord_identificador.substring(10, 14)}`,
          header: "# ORDEN",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "usr_nombre",
          header: "CAJA",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "cli_nombre",
          header: "CLIENTE",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "ord_fecha",
          accessorFn: (row) =>
            `${
              row.ord_fecha !== "0000-00-00 00:00:00" ? FORMATO_AM_PM(new Date(row.ord_fecha)) : ""
            }`,
          header: "FECHA",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "ordd_total",
          accessorFn: (row) => `$${ Number(row.ordd_total).toFixed(2)}`,
          header: "TOTAL",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}
export function COLUMNS_LISTA_ORDENES() {
  return [
    {
      accessorKey: "usr_nombre",
      header: "MESERO",
      enableGlobalFilter: true,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },
    {
      accessorKey: "ord_identificador",
      accessorFn: (row) => `${row.ord_identificador.substring(10, 14)}`,
      header: "# ORDEN",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "res_nombre",
      header: "# MESA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "ord_fecha",
      accessorFn: (row) =>
        `${row.ord_fecha !== "0000-00-00 00:00:00" ? FORMATO_AM_PM(new Date(row.ord_fecha)) : ""}`,
      header: "FECHA",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "ordd_total",
      accessorFn: (row) => `${parseFloat(row.ordd_total).toFixed(2)}`,
      header: "TOTAL",
      size: 80,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}
export function COLUMNS_LISTA_COTIZACION() {
  return window.innerWidth <= 611
    ? [
            {
          header: "COTIZACIÓN",
          accessorFn: (row) =>
            `${row.cot_id} ${row.cli_nombre} ${row.cot_fecha} ${row.cot_descripcion} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b># COTIZACIÓN {highlightText(row.original.cot_id.toString().padStart(10, "0"), search)} - {highlightText(row.original.cli_nombre, search)}</b>
                  </span>
                  <br></br>
                  <span>DESCRIPCIÓN : {highlightText(row.original.cot_descripcion, search)}</span>
                  <br></br>
                  <span>CLIENTE : {highlightText(row.original.cli_nombre, search)}</span>
                  <br></br>
                  <span>FECHA : {highlightText(row.original.cot_fecha !== "00-00-0000" ? highlightText(row.original.cot_fecha, search):"") } </span>
                  <br></br>
                  <span className="float-end label-money"><b>{" "}
                    TOTAL :{" $"}
                    {format_miles({num:MONEY_ROUND(row.original.cotd_total)}) }</b>
                    
                  </span>{" "}
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
        {
          accessorKey: "cot_id",
          header: "# COTIZACIÓN",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cli_nombre",
          accessorFn: (row) =>
            `${row.cli_ruc !== "" ? row.cli_nombre + " " + row.cli_ruc : row.cli_nombre}`,
          header: "NOMBRE",
          enableGlobalFilter: true,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },

        {
          accessorKey: "cot_descripcion",
          header: "DESCRIPCIÓN",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cot_fecha",
          header: "FECHA",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "cotd_total",
          accessorFn: (row) => `$ ${MONEY_ROUND(row.cotd_total)}`,
          header: "TOTAL",
          size: 80,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];
}
export function COLUMNS_EXISTENCIA_INVENTARIO() {
  return [
    {
      accessorKey: "art_upc",
      header: "CÓDIGO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "art_descripcion",
      header: "ARTÍCULO",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "art_categoria",
      header: "CATEGORIA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "art_marca",
      header: "MARCA",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "inv_qty",
      header: "CANTIDAD",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];
}
export function COLUMNS_LISTA_CLIENTE() {   
  return window.innerWidth <= 611
    ? [
        {accessorFn: (row) =>
            `${row.cli_ruc} ${row.cli_nombre} ${row.cli_telefono} ${row.cli_email} `,
          Cell: ({ row,table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left">
                <Col xs={12} className="font-size-dt">
                  <span className="label-art-upc">
                    <b>CLIENTE: {highlightText(row.original.cli_nombre, search)}</b>
                  </span>
                  <br></br>

                  {row.original.cli_ruc.length > 0 ? (
                    <>
                      <span>
                        RUC :{" "}
                        {row.original.cli_ruc.toLowerCase().includes("dv")?highlightText(row.original.cli_ruc, search):<>{row.original.cli_dv !== ""
                          ? highlightText(row.original.cli_ruc, search) + " DV " + row.original.cli_dv
                          : highlightText(row.original.cli_ruc, search)}</>}

                      </span>
                      <br></br>
                    </>
                  ) : null}
                 
                  {row.original.cli_telefono.length > 0 ? (
                    <span>
                      Teléfono : {highlightText(row.original.cli_telefono, search)} <br></br> E-MAIL :{" "}
                      {highlightText(row.original.cli_email, search)}
                    </span>
                  ) : null}
                </Col>
              </Row>
            );
          },
          accessorKey: "cli_nombre",
          header: "CLIENTE",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "cli_nombre",
          header: "NOMBRE",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
        {
          accessorKey: "cli_ruc",
          header: "RUC",
          accessorFn: (row) =>
            `${row.cli_dv !== "" ? row.cli_ruc + " DV " + row.cli_dv : row.cli_ruc}`,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
        {
          accessorKey: "cli_telefono",
          header: "TELÉFONO",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
        {
          accessorKey: "cli_email",
          header: "E-MAIL",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          enableEditing: true,
        },
      ];
}
export const COLUMNS_GAS_GASTOS =
  window.innerWidth <= 611
    ? [
        {
          Cell: ({ cell }) => {
            return (
              <Row className="text-left  d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>
                      ID: {cell.row.original.gs_id} - {cell.row.original.tgs_desc}
                    </b>
                  </span>
                  <br></br>

                  <span>
                    Fecha : {cell.row.original.gs_fecha} <br></br> Sucursal :{" "}
                    {cell.row.original.com_alias} <br></br> Descripción :{" "}
                    {cell.row.original.gs_desc}
                  </span>
                  <br></br>
                  <span className="float-end label-money">
                    <b>
                      MONTO : $
                      {MONEY_ROUND(cell.row.original.gs_monto) }
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          accessorKey: "gs_id",
          header: "GASTOS",
          grow: true,
          enableEditing: false,
        },
      ]
    : [
        {
          accessorKey: "gs_id",
          header: "ID",
          size: 50,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "com_alias",
          header: "SUCURSAL",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "gs_desc",
          header: "DESCRIPCIÓN",
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "left",
          },
        },
        {
          accessorKey: "gs_monto", //normal accessorKey
          header: "MONTO",
          size: 60,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "tgs_desc", //normal accessorKey
          header: "TIPO DE GASTO",
          size: 100,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          accessorKey: "gs_fecha", //normal accessorKey
          header: "FECHA",
          size: 60,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
      ];

export const COLUMNS_TRAZABILIDAD =
   window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",
          accessorFn: (row) =>
            `${row.art_upc} ${row.art_categoria} ${row.art_descripcion} ${row.art_marca} ${row.art_linea_roja} ${row.inv_qty} `,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>{highlightText(row.original.art_upc, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    DESCRIPCIÓN: {highlightText(row.original.art_descripcion, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    CATEGORIA: {highlightText(row.original.art_categoria, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    MARCA: {highlightText(row.original.art_marca, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14 float-start label-money">
                    <b>
                      LÍNEA ROJA:{" "}
                      {highlightText(
                        (row.original.art_linea_roja).toFixed(2),
                        search
                      )}
                    </b>
                  </span>
                  <span className="font-w-14 float-end label-money">
                    <b>
                      EXISTENCIA:{" "}
                      {highlightText(
                        new Decimal(row.original.inv_qty).toFixed(2),
                        search
                      )}
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        }
      ]:[{
    accessorKey: "art_upc",
    header: "CÓDIGO",
  },
  {
    accessorKey: "art_descripcion", //normal accessorKey
    header: "DESCRIPCIÓN",
  },
  {
    accessorKey: "art_categoria", //normal accessorKey
    header: "CATEGORIA",
  },
  {
    accessorKey: "art_marca", //normal accessorKey
    header: "MARCA",
  },
  {
    accessorKey: "art_linea_roja", //normal accessorKey
    header: "LÍNEA ROJA",
  },
  {
    accessorKey: "inv_qty", //normal accessorKey
    header: "EXISTENCIA",
  },
];
export const COLUMNS_MOV_MOVIMIENTO = [
  {
    accessorKey: "mov_id",
    header: "# MOVIMIENTO",
    size: 60,
  },
  {
    accessorKey: "mov_descripcion", //normal accessorKey
    header: "DESCRIPCIÓN",
  },
  {
    accessorKey: "bod_desde", //normal accessorKey
    header: "BODEGA INICIO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "bod_hacia", //normal accessorKey
    header: "BODEGA FINAL",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorFn: (row) =>
      `${
        row.mov_fecha !== "0000-00-00 00:00:00" ? moment(row.mov_fecha).format("YYYY-MM-DD") : ""
      }`,
    accessorKey: "mov_fecha", //normal accessorKey
    header: "FECHA",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 40,
    minSize: 60,
  },
  {
    accessorFn: (row) =>
      `${
        row.mov_fecha_procesado !== "0000-00-00 00:00:00"
          ? moment(row.mov_fecha_procesado).format("YYYY-MM-DD")
          : ""
      }`,
    accessorKey: "mov_fecha_procesado", //normal accessorKey
    header: "F. PROCESADO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 40,
    minSize: 60,
  },
];
export const COLUMNS_ENTRADA_INVENTARIO = window.innerWidth <= 611? [
        {
          header: "ENTRADA POR INVENTARIO",
          accessorFn: (row) =>
            `${row.re_id} ${row.com_alias} ${row.bod_nombre} ${row.re_fecha} ${row.re_fecha_procesado} ${row.art_upc} ${row.art_descripcion} ${row.red_cantidad}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># INVENTARIO {highlightText(row.original.re_id, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    SUCURSAL: {highlightText(row.original.com_alias, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    BODEGA: {highlightText(row.original.bod_nombre, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    F. INVENTARIO: {highlightText(row.original.re_fecha !== "0000-00-00 00:00:00" ? moment(row.original.re_fecha).format("YYYY-MM-DD") : "", search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    F. PROCESADO:{highlightText(row.original.re_fecha_procesado !== "0000-00-00 00:00:00" ? highlightText(FORMATO_AM_PM(new Date(row.original.re_fecha_procesado)), search) : "", search)}
                  </span>
                  <br></br>
                  <span className="font-w-14 float-end label-money"><b>CANTIDAD: {highlightText(row.original.red_cantidad, search)}</b></span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "re_id",
    header: "# INVENTARIO",
    size: 80,
  },
  {
    accessorKey: "com_alias", //normal accessorKey
    header: "SUCURSAL",
    size: 150,
  },
  {
    accessorKey: "bod_nombre", //normal accessorKey
    header: "BODEGA",
    size: 150,
  },
    {
    accessorKey: "re_fecha", //normal accessorKey
    header: "F. INVENTARIO",
    size: 150,
  },
  {
    accessorKey: "re_fecha_procesado", //normal accessorKey
    accessorFn: (row) =>
      `${row.re_fecha_procesado !== "0000-00-00 00:00:00" ? moment(row.re_fecha_procesado).format("YYYY-MM-DD") : ""}`,
    header: "F. PROCESADO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "art_upc", //normal accessorKey
    header: "CÓDIGO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "red_cantidad", //normal accessorKey
    header: "CANTIDAD",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  }
];
export const COLUMNS_ENTRADA_FACTURA_COMPRA = window.innerWidth <= 611? [
        {
          header: "ENTRADA POR FACTURA DE COMPRA",
          accessorFn: (row) =>
            `${row.dc_docn} ${row.com_alias} ${row.bod_nombre} ${row.dc_fecha} ${row.dc_fecha_procesado} ${row.art_upc} ${row.art_descripcion} ${row.dcd_cantidad}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># DOCUMENTO {highlightText(row.original.dc_docn, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    SUCURSAL: {highlightText(row.original.com_alias, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    BODEGA: {highlightText(row.original.bod_nombre, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    F. DOCUMENTO:{highlightText(row.original.dc_fecha !== "0000-00-00 00:00:00" ? moment(row.original.dc_fecha).format("YYYY-MM-DD") : "", search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    F. PROCESADO: {highlightText(row.original.dc_fecha_procesado !== "0000-00-00 00:00:00" ? highlightText(FORMATO_AM_PM(new Date(row.original.dc_fecha_procesado)), search) : "", search)}
                  </span>
                  <br></br>
                  <span className="font-w-14 float-end label-money"><b> CANTIDAD: {highlightText(row.original.dcd_cantidad, search)}</b></span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "dc_docn",
    header: "# DOCUMENTO",
    size: 80,
  },
  {
    accessorKey: "com_alias", //normal accessorKey
    header: "SUCURSAL",
    size: 150,
  },
  {
    accessorKey: "bod_nombre", //normal accessorKey
    header: "BODEGA",
    size: 150,
  },
    {
    accessorKey: "dc_fecha", //normal accessorKey
    header: "F. INVENTARIO",
    size: 150,
  },
  {
    accessorKey: "re_fecha_procesado", //normal accessorKey
    accessorFn: (row) =>
      `${row.dc_fecha_procesado !== "0000-00-00 00:00:00" ? moment(row.dc_fecha_procesado).format("YYYY-MM-DD") : ""}`,
    header: "F. PROCESADO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "art_upc", //normal accessorKey
    header: "CÓDIGO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "dcd_cantidad", //normal accessorKey
    header: "CANTIDAD",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  }
];
export const COLUMNS_SALIDA_VENTA = window.innerWidth <= 611? [
        {
          header: "SALIDA POR VENTA",
          accessorFn: (row) =>
            `${row.fac_id} ${row.com_alias} ${row.fac_fecha} ${row.usr_nombre} ${row.fcd_cantidad}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";
            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># FACTURA {highlightText(row.original.fac_id, search)}</b>
                  </span>
                  <br />
                  <span className="font-w-14">
                    SUCURSAL: {highlightText(row.original.com_alias, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    FECHA: {highlightText(row.original.fac_fecha !== "0000-00-00 00:00:00" ? moment(row.original.fac_fecha).format("YYYY-MM-DD") : "", search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    VENDEDOR: {highlightText(row.original.usr_nombre, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14 float-end label-money">
                    <b>
                      CANTIDAD:{" "}
                      {highlightText(
                        new Decimal(row.original.fcd_cantidad).toFixed(2),
                        search
                      )}
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "fac_id",
    header: "# FACTURA",
    size: 80,
  },
  {
    accessorKey: "com_alias", //normal accessorKey
    header: "SUCURSAL",
    size: 150,
  },
  {
    accessorKey: "fac_fecha", //normal accessorKey
    accessorFn: (row) =>
      `${row.fac_fecha !== "0000-00-00 00:00:00" ? moment(row.fac_fecha).format("YYYY-MM-DD") : ""}`,
    header: "FECHA",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "usr_nombre", //normal accessorKey
    header: "VENDEDOR",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "fcd_cantidad", //normal accessorKey
    header: "CANTIDAD",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  }
];

export const COLUMNS_RE_CUENTO = window.innerWidth <= 611? [
        {
          header: "INVENTARIO",
          accessorFn: (row) =>
            `${row.art_upc} ${row.re_id} ${row.re_descripcion} ${row.com_alias} ${row.bod_nombre} ${row.re_fecha} ${row.re_fecha_procesado}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b># INVENTARIO {highlightText(row.original.re_id, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    DESCRIPCIÓN: {highlightText(row.original.re_descripcion, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    SUCURSAL: {highlightText(row.original.com_alias, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    BODEGA: {highlightText(row.original.bod_nombre, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    FECHA: {highlightText(row.original.re_fecha, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14">
                    FECHA PROCESADO: {row.original.re_procesado==="0"?"":highlightText(row.original.re_fecha_procesado, search)}
                  </span>
                  <br></br>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
      ]
    : [
  {
    accessorKey: "re_id",
    header: "# INVENTARIO",
    size: 80,
  },
  {
    accessorKey: "re_descripcion", //normal accessorKey
    header: "DESCRIPCIÓN",
    size: 150,
  },
  {
    accessorKey: "com_alias", //normal accessorKey
    header: "SUCURSAL",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "bod_nombre", //normal accessorKey
    header: "BODEGA",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorKey: "re_fecha", //normal accessorKey
    accessorFn: (row) =>
      `${row.re_fecha !== "0000-00-00 00:00:00" ? moment(row.re_fecha).format("YYYY-MM-DD") : ""}`,
    header: "FECHA",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
  {
    accessorFn: (row) =>
      `${
        row.re_fecha_procesado !== "0000-00-00 00:00:00"
          ? FORMATO_AM_PM(new Date(row.re_fecha_procesado))
          : ""
      }`,
    accessorKey: "re_fecha_procesado", //normal accessorKey
    header: "FECHA PROCESADO",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    size: 100,
  },
];
export function COLUMNS_RE_RECUENTO_DETALLE() {
  return window.innerWidth <= 611
    ? [
        {
          header: "ARTÍCULO",
          accessorFn: (row) =>
            `${row.art_upc} ${row.art_referencia} ${row.art_descripcion} ${row.mar_descripcion} ${row.art_precio}`,
          Cell: ({ row, table }) => {
            const search = table.getState().globalFilter ?? "";

            return (
              <Row className="text-left d-content">
                <Col xs={12} className="col-sin-padding font-size-dt">
                  <span className="label-art-upc">
                    <b>{highlightText(row.original.art_upc, search)}</b>
                  </span>

                  <br />
                  <span className="font-w-14">
                    DESCRIPCIÓN: {highlightText(row.original.art_descripcion, search)}
                  </span>
                  <br></br>
                  <span className="font-w-14 float-end label-money">
                    <b>
                      CONTEO:{" "}
                      {highlightText(
                        new Decimal(row.original.red_cantidad).toFixed(2),
                        search
                      )}
                    </b>
                  </span>
                </Col>
              </Row>
            );
          },
          filterFn: "fuzzy",
          enableGlobalFilter: true,
          enableEditing: false,
          grow: true,
        },
        {
          header: "UPC",
          accessorKey: "art_upc",
          enableEditing: false, // solo lectura
        },

        {
          header: "Descripción",
          accessorKey: "art_descripcion",
          enableEditing: false,
        },

        {
          header: "Conteo",
          accessorKey: "red_cantidad",
          enableEditing: true,
          muiEditTextFieldProps: {
            type: "number",
            inputProps: { step: "0.01" },
          },
        },
      ]
    : [
        {
          accessorKey: "art_upc", //access nested data with dot notation
          header: "CÓDIGO",
          size: 120,
          minSize: 100,
          enableEditing: false,
        },
        {
          accessorKey: "art_descripcion",
          header: "DESCRIPCIÓN",
          size: 250,
          minSize: 200,
          enableEditing: false,
        },

        {
          Cell: ({ cell }) => {
            return (
              <Row>
                <Col xs={12} className="text-center">
                  <span>{`${new Decimal(cell.row.original.red_cantidad).toFixed(2)}`}</span>
                </Col>
              </Row>
            );
          },
          accessorKey: "red_cantidad",
          header: "CANTIDAD",
          size: 40,
          minSize: 40,
        },
      ];
}
export function COLUMNS_MOVD_MOVIMIENTO_DETALLE() {
  return [
    {
      accessorKey: "art_upc", //access nested data with dot notation
      header: "CÓDIGO",
      size: 120,
      minSize: 100,
      enableEditing: false,
    },
    {
      accessorKey: "art_descripcion",
      header: "DESCRIPCIÓN",
      size: 230,
      minSize: 200,
      enableEditing: false,
    },
    {
      accessorKey: "inv_qty",
      header: "EXISTENCIA EN BODEGA",
      size: 80,
      minSize: 60,
      enableEditing: false,
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.inv_qty).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
    },
    {
      Cell: ({ cell }) => {
        return (
          <Row>
            <Col xs={12} className="text-center">
              <span>{`${new Decimal(cell.row.original.movd_cantidad).toFixed(2)}`}</span>
            </Col>
          </Row>
        );
      },
      accessorKey: "movd_cantidad",
      header: "CANTIDAD A MOVER",
      size: 40,
      minSize: 40,
    },
  ];
}
